<script lang="ts">
	import { create } from "@bufbuild/protobuf";
	import { ImagePlaceholder } from "flowbite-svelte-v1";
	import { writable } from "svelte/store";
	import { twMerge } from "tailwind-merge";
	import { AdUnitSchema } from "#gen/bundles/v1/bundle_pb.js";
	import { Mode } from "#gen/bundles/v1/service_pb.js";
	import type { AssetLoad } from "#lib/api/bundles.js";
	import Badge from "#lib/components/Badge.svelte";

	interface Props {
		asset: AssetLoad;
		mode: Mode;
		class?: string;
	}

	const { asset, mode, class: className }: Props = $props();
	const ad = $derived(asset?.asAdUnit() ?? writable(create(AdUnitSchema)));
</script>

{#snippet renderPlaceholder()}
	<ImagePlaceholder size="sm" class="animate-none" classes={{ image: "bg-gray-100 bg-gray-100 rounded-lg", svg: "text-gray-400" }} />
	{#if mode === Mode.EDITING}
		<Badge large border class="absolute top-4 right-4">Ad</Badge>
	{/if}
{/snippet}

<div class={twMerge("flex h-39.75 w-full flex-col overflow-hidden rounded-2xl bg-white p-0", mode === Mode.EDITING && className)}>
	{#if mode === Mode.EDITING}
		{@render renderPlaceholder()}
	{:else if $ad?.content.case === "html"}
		<!-- eslint-disable-next-line svelte/no-at-html-tags -->
		{@html $ad.content.value}
	{/if}
</div>
